import React from 'react';
import PropTypes from 'prop-types';

import './badgeStyles.scss';

class MultiBadge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, active, onClick, showIcon } = this.props;
    return (
      <div className={active ? 'chip active' : 'chip'} onClick={onClick}>
        <span>
          {showIcon && (
            <>
              <div className="chip-multi-icon">
                <i className={'os-icon os-icon-grid-10'}/>
              </div>{' '}
              {label}{' '}
            </>
          )}
          {!showIcon && label}
        </span>
      </div>
    );
  }
}

MultiBadge.defaultProps = {
  active: false,
  showIcon: true,
  onClick: null,
};
MultiBadge.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  showIcon: PropTypes.bool,
  onClick: PropTypes.func,
};
export default MultiBadge;
